









































































































import { Vue, Component } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';
import ManagerService from '@/api/ManagerService';
import SignInService from '@/api/SigninService';
import BillingService from '@/api/BillingService';
import SellCoinsService from '@/api/SellCoinsService';
import BusinessService from '@/api/BusinessService';
import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';
import {
  setMerchantInviteState,
  removeMerchantInviteState,
  removeMerchantMeetingOboardingState
} from '@/router/router-utils';

import refreshBusinessInformation from '@/utils/refresh-business-information';
import HTTPStatus from '@/constants/httpStatus';
import eventBus from '@/utils/eventBus';
import segmentIo from '@/utils/segment.io';
import { convertCoinsPurchasePercentToRatio } from '@/utils/coinsHelper';
import { updateRegistration } from '@/utils/updateRegistration';
import logger from '@/utils/logger';
import jwtDecode from 'jwt-decode';

import flagKeys from '@/constants/flagKeys';
import { SalesOnboardingFormState } from '@/models/sales-onboarding';
import {
  EAutomaticCampaignName,
  EIncentiveType,
  ESellCoinsCampaignStatus
} from '@/models/sell-coins';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { removeSalesOnboardingDataOnSessionStorage } from '@/store/modules/salesOnboarding';
import { EProgramStatusStatus } from '@/models/program-status';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';

import { FilledButton } from '@/components/molecules';
import AccountPasswordForm from '@/componentsV2/templates/AccountPasswordForm/AccountPasswordForm.vue';
import InviteMailBox from '@/componentsV2/molecules/InviteMailBox/InviteMailBox.vue';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ConfirmYourInfo from './Steps/ConfirmYourInfo.vue';
import ConfirmYourFeatures from './Steps/ConfirmYourFeatures.vue';
import OnboardingMeetingScheduling from './Steps/OnboardingMeetingScheduling.vue';
import { getMerchantInviteState } from '@/router/router-utils';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { OnboardingURL } from '@/views/Onboarding/helpers';

export enum EYourAccountInvitationStepSlug {
  CONFIRM_YOUR_INFO = 'confirm-your-info',
  CONFIRM_YOUR_FEATURES = 'confirm-your-features',
  CHANGE_PASSWORD = 'change-password',
  ONBOARDING_MEETING_SCHEDULING = 'onboarding-call-scheduling'
}

@Component({
  components: {
    FilledButton,
    AccountPasswordForm,
    InviteMailBox,
    TwismLogoIcon,
    Typography,
    ConfirmYourInfo,
    ConfirmYourFeatures,
    OnboardingMeetingScheduling
  }
})
export default class InvitationMerchantCreateAccount extends Vue {
  signUpService = new SignUpService({ disableToastMessage: true });
  managerService = new ManagerService();
  signInService = new SignInService();
  billingService = new BillingService();
  sellCoinsService = new SellCoinsService();
  businessService = new BusinessService();
  offerFreeCoinsService = new OfferFreeCoinsService();

  loading = false;
  offerWithoutLocation = false;
  welcomeCoinsWithoutCoins = false;
  loyaltyWithoutSettings = false;
  inviteCode = '';
  inviteData: Record<string, any> = {};

  triggerAnimation = true;

  activeStepSlug = EYourAccountInvitationStepSlug.CONFIRM_YOUR_INFO;
  stepIndicator = 1;

  auxiliaryButtonDefault = {
    label: 'Back',
    onPress: () => this.handleBack()
  };

  primaryButtonDefault = {
    label: 'Next',
    onPress: () => this.goToNextStep()
  };

  steps: Record<string, any> = {
    [EYourAccountInvitationStepSlug.CONFIRM_YOUR_INFO]: {
      component: 'ConfirmYourInfo',
      auxiliaryButton: {
        label: 'Preview on App',
        onPress: () => this.handleClickPreviewOnApp()
      },
      title: 'Confirm your info'
    },
    [EYourAccountInvitationStepSlug.CONFIRM_YOUR_FEATURES]: {
      component: 'ConfirmYourFeatures',
      title: 'Confirm your features'
    },
    [EYourAccountInvitationStepSlug.CHANGE_PASSWORD]: {
      component: 'AccountPasswordForm'
    },
    [EYourAccountInvitationStepSlug.ONBOARDING_MEETING_SCHEDULING]: {
      component: 'OnboardingMeetingScheduling'
    }
  };

  get primaryButton() {
    if (this.steps[this.activeStepSlug].primaryButton)
      return this.steps[this.activeStepSlug].primaryButton;

    if (
      this.isLastStep ||
      (this.isLastButOneStep && this.hasOnboardingMeetingSchedulingStep)
    ) {
      return {
        label: !this.hasOnboardingMeetingSchedulingStep
          ? 'Activate my Account'
          : 'Next',
        onPress: () => this.onSubmit()
      };
    }

    return this.primaryButtonDefault;
  }

  get activeStepIndex() {
    return this.activeStepsInTheFlow.indexOf(this.activeStepSlug);
  }

  get auxiliaryButton() {
    if (this.steps[this.activeStepSlug].auxiliaryButton)
      return this.steps[this.activeStepSlug].auxiliaryButton;

    return this.auxiliaryButtonDefault;
  }

  get isLastButOneStep() {
    return this.activeStepsInTheFlow.length - 2 === this.activeStepIndex;
  }

  get isLastStep() {
    return this.activeStepsInTheFlow.length === this.activeStepIndex + 1;
  }

  get isOnboardingMeetingSchedulingStep() {
    return this.hasOnboardingMeetingSchedulingStep && this.isLastStep;
  }

  get totalSteps() {
    return Object.keys(this.activeStepsInTheFlow).length;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get hasOnboardingMeetingSchedulingStep() {
    if (
      !this.flags.includes(flagKeys.salesOnboardingCallRequired) ||
      !this.inviteData.onboardingMeeting
    )
      return false;

    const { onboardingMeeting } = this.inviteData;

    return (
      onboardingMeeting.status &&
      onboardingMeeting.status === EOnboardingMeetingStatus.PENDING
    );
  }

  get isFeatureFlagLoginHandleActive() {
    return this.flags.includes(flagKeys.dashboardBusinessOwnershipLoginHandle);
  }

  get experienceWithCoinsEnabled() {
    return this.flags.includes(
      flagKeys.dashboardBusinessOwnershipExperienceWithCoins
    );
  }

  get salesOnboardingFormData() {
    return (
      (this.$store.getters[
        'salesOnboarding/getFormData'
      ] as SalesOnboardingFormState) || {}
    );
  }

  get hasConfirmYourFeaturesStep() {
    const { refundsLimitDays, rewardPercentage } =
      this.inviteData.loyaltyRewards || {};

    return (
      this.experienceWithCoinsEnabled &&
      (!!this.inviteData.sellCoins ||
        !!refundsLimitDays ||
        !!rewardPercentage ||
        !!this.inviteData.welcomeCoins)
    );
  }

  get hasChangePasswordStep() {
    const { isManagerAlreadyRegistered } = this.inviteData;

    return !isManagerAlreadyRegistered || !this.isFeatureFlagLoginHandleActive;
  }

  get activatedSomeCoinsFeature() {
    const {
      sellCoins,
      loyaltyRewards,
      welcomeCoins
    } = this.salesOnboardingFormData;

    const { refundsLimitDays, rewardPercentage } = loyaltyRewards || {};

    return (
      !!sellCoins ||
      !!refundsLimitDays ||
      !!rewardPercentage ||
      !!(welcomeCoins && welcomeCoins.enabled)
    );
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get coinPurchaseRatio() {
    const { loyaltyRewards } = this.salesOnboardingFormData;

    if (!loyaltyRewards) return 0;

    return convertCoinsPurchasePercentToRatio(loyaltyRewards.rewardPercentage);
  }

  get hasBillingTerms() {
    return this.hasConfirmYourFeaturesStep && this.activatedSomeCoinsFeature;
  }

  get activeStepsInTheFlow() {
    const steps: EYourAccountInvitationStepSlug[] = [
      EYourAccountInvitationStepSlug.CONFIRM_YOUR_INFO
    ];

    if (this.hasConfirmYourFeaturesStep)
      steps.push(EYourAccountInvitationStepSlug.CONFIRM_YOUR_FEATURES);

    if (this.hasChangePasswordStep)
      steps.push(EYourAccountInvitationStepSlug.CHANGE_PASSWORD);

    if (this.hasOnboardingMeetingSchedulingStep)
      steps.push(EYourAccountInvitationStepSlug.ONBOARDING_MEETING_SCHEDULING);

    return steps;
  }

  created() {
    const dataParams = getMerchantInviteState();

    this.inviteData = dataParams;

    if (!this.hasConfirmYourFeaturesStep) {
      this.setSalesOnboardingFormData();
      return;
    }

    this.handleCoinFeatureStep();
  }

  verifyOffersLocations() {
    const offers = this.inviteData.offers;

    offers.map((offer: any) => {
      if (!this.offerWithoutLocation) {
        if (!offer.locations || !offer.locations.length) {
          this.offerWithoutLocation = true;
          this.$notification('Location is required for the offer.', 'error');
        }
      }
    });
  }

  setSalesOnboardingFormData(data?: SalesOnboardingFormState) {
    this.$store.dispatch('salesOnboarding/SET_FORM_DATA', data || {});
  }

  handleCoinFeatureStep() {
    if (
      !this.salesOnboardingFormData.inviteCode ||
      (this.salesOnboardingFormData.inviteCode &&
        this.salesOnboardingFormData.inviteCode !== this.inviteData.inviteCode)
    ) {
      const { welcomeCoins, loyaltyRewards } = this.inviteData;

      const welcomeCoinsIsEnabled = welcomeCoins && welcomeCoins.coins;

      this.setSalesOnboardingFormData({
        inviteCode: this.inviteData.inviteCode,
        loyaltyRewards: {
          enabled: !!loyaltyRewards,
          ...loyaltyRewards
        },
        welcomeCoins: {
          enabled: welcomeCoinsIsEnabled,
          value: welcomeCoinsIsEnabled
            ? String(this.inviteData.welcomeCoins.coins)
            : ''
        },
        sellCoins: !!this.inviteData.sellCoins,
        billingSubscription: this.inviteData.billingSubscription
      });
    }
  }

  includeCoinFeaturesStep() {
    this.steps = {
      ...this.steps
    };
  }

  trakingEventUpdatedFeatures() {
    const {
      sellCoins,
      loyaltyRewards,
      welcomeCoins
    } = this.salesOnboardingFormData;

    const { refundsLimitDays, rewardPercentage } = loyaltyRewards || {};

    const {
      sellCoins: oldSellCoins,
      loyaltyRewards: oldLoyaltyRewards,
      welcomeCoins: oldWelcomeCoins
    } = this.inviteData;

    const {
      refundsLimitDays: oldRefundsLimitDays,
      rewardPercentage: oldRewardPercentage
    } = oldLoyaltyRewards || {};

    let featuresChanged = {};

    if (sellCoins !== oldSellCoins) {
      featuresChanged = {
        ...featuresChanged,
        'Sell Coins Old': oldSellCoins,
        'Sell Coins': sellCoins,
        'Sell Coins Changed': true
      };
    } else {
      featuresChanged = {
        ...featuresChanged,
        'Sell Coins Changed': false
      };
    }

    if (welcomeCoins && welcomeCoins.value !== oldWelcomeCoins.coins) {
      featuresChanged = {
        ...featuresChanged,
        'Welcome Coins Old': oldWelcomeCoins.coins,
        'Welcome Coins': welcomeCoins.value,
        'Welcome Coins Changed': true
      };
    } else {
      featuresChanged = {
        ...featuresChanged,
        'Welcome Coins Changed': false
      };
    }

    if (refundsLimitDays !== oldRefundsLimitDays) {
      featuresChanged = {
        ...featuresChanged,
        'Refunds Limit Days Old': oldRefundsLimitDays,
        'Refunds Limit Days': refundsLimitDays,
        'Refunds Limit Days Changed': true
      };
    } else {
      featuresChanged = {
        ...featuresChanged,
        'Refunds Limit Days Changed': false
      };
    }

    if (rewardPercentage !== oldRewardPercentage) {
      featuresChanged = {
        ...featuresChanged,
        'Reward Percentage Old': oldRewardPercentage,
        'Reward Percentage': rewardPercentage,
        'Reward Percentage Changed': true
      };
    } else {
      featuresChanged = {
        ...featuresChanged,
        'Reward Percentage Changed': false
      };
    }

    segmentIo.track(
      'Confirm Coin features (Ownership experience)',
      featuresChanged
    );
  }

  async handleChangePassword(password: string) {
    this.loading = true;

    const { status } = await this.managerService.changePassword({
      code: this.inviteData.inviteCode,
      newPassword: password,
      withCoins: !!this.activatedSomeCoinsFeature
    });

    if (status !== 200) return;

    const managerEmail = this.inviteData.managers[0].manager.mail;

    const { data, ...rest } = (await this.signInService.login(
      password,
      managerEmail,
      'manager'
    )) as any;

    if (data && data.access_token) {
      this.signInService.setCredentials(data.access_token, false);

      await this.setBusiness().finally(() => this.handleAcceptInvite());

      return;
    }

    const messageError = this.getMessageErrorLogion(rest.response);
    throw new Error(messageError);
  }

  async setBusiness() {
    this.loading = true;
    if (!this.inviteData.businessId) return;

    const { data, status } = await this.managerService.connect(
      this.inviteData.businessId
    );

    if (status === 201) {
      const { access_token } = data;
      segmentIo.reset();
      logger.reset();
      this.$store.dispatch('stripe/SET_STRIPE_DATA', '');
      this.businessService.setCredentials(
        access_token,
        jwtDecode(access_token).extraInfo.isImpersonated
      );

      this.handleUpdateBusiness();
    }

    this.loading = false;
  }

  async handleUpdateBusiness() {
    const { status, data } = await this.businessService.getBusinessInfo();

    if (status !== 200) return;

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...data,
      manager: data.loggedInManager
    });
  }

  async claimAccount() {
    const {
      status
    } = await this.managerService.acceptClaimAccountHubspotIntegration({
      code: this.inviteData.inviteCode
    });

    this.loading = false;

    if (status !== 201) return;

    refreshBusinessInformation();

    this.inviteData = {
      ...this.inviteData,
      claimed: true
    };
    setMerchantInviteState(this.inviteData);

    this.goToWelcome();
  }

  async handleAcceptInvite() {
    this.loading = true;

    if (this.hasConfirmYourFeaturesStep && this.activatedSomeCoinsFeature) {
      this.activateSubscription();
      this.trakingEventUpdatedFeatures();
      return;
    }

    this.claimAccount();
  }

  async activateSubscription() {
    const { status } = await this.billingService.acceptTermsSubscription();
    const {
      status: statusActivate
    } = await this.billingService.activateSubscription('HubSpot');

    if (status !== 201 || statusActivate !== 201) {
      this.loading = false;
      return;
    }

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      subscriptionStatus: EBillingStatusTypes.SUBSCRIBED
    });

    try {
      await Promise.all([
        this.setLoyaltySetting(),
        this.setSellCoins(),
        this.setWelcomeCoins()
      ]);
    } finally {
      this.claimAccount();
    }
  }

  goToWelcome() {
    if (this.hasOnboardingMeetingSchedulingStep) {
      this.goToNextStep();
      return;
    }

    removeMerchantInviteState();
    removeSalesOnboardingDataOnSessionStorage();
    this.$router.push(OnboardingURL.WELCOME_TWISM);
  }

  async setWelcomeCoins() {
    const { welcomeCoins } = this.salesOnboardingFormData;

    if (!welcomeCoins || !welcomeCoins.value) return;

    const payload: any = {
      coinsReward: Number(welcomeCoins.value),
      allowRepeatingCustomers: false,
      limitType: 'no-limit',
      status: 'active',
      visibilityType: 'local',
      source: 'HubSpot'
    };

    this.offerFreeCoinsService.createOfferFreeCoin(payload);
  }

  async setSellCoins() {
    const { sellCoins, loyaltyRewards } = this.salesOnboardingFormData;

    const { status, data } = await this.businessService.updateSellCoins(
      sellCoins || false,
      DashboardScreen.HubSpotIntegration
    );

    if (status !== 200 && status !== 201) return;

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      sellCoins: data.sellCoins
    });

    if (loyaltyRewards && loyaltyRewards.rewardPercentage) {
      return;
    }

    await this.sellCoinsService.createSellingCoinsCampaign({
      name: EAutomaticCampaignName.first,
      incentiveValue: 0,
      incentiveType: EIncentiveType.BONUS,
      automaticallyCreated: true,
      source: 'HubSpot'
    });
  }

  async setLoyaltySetting() {
    const { sellCoins, loyaltyRewards } = this.salesOnboardingFormData;

    if (!loyaltyRewards) return;

    const {
      rewardPercentage: coinRewardPercentage,
      refundsLimitDays
    } = loyaltyRewards;

    const payload = {
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage,
      refundsLimitDays,
      sellCoinsAction: null,
      source: 'HubSpot'
    };

    const { status } = await this.signUpService.setupRules(payload);

    if (status !== 200 && status !== 201) return;

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      refundsLimitDays: refundsLimitDays,
      coinRewardPercentage: coinRewardPercentage,
      coinPurchaseRatio: this.coinPurchaseRatio,
      rewardStatus: EProgramStatusStatus.ACTIVE,
      operationStatus: EProgramStatusStatus.ACTIVE
    });

    updateRegistration('manage-rewards');
    updateRegistration('return-policy');

    if (!sellCoins) return;

    const {
      data: sellCoinsData,
      status: sellCoinsStatus
    } = await this.sellCoinsService.createSellingCoinsCampaign({
      name: EAutomaticCampaignName.loyalt,
      incentiveValue: coinRewardPercentage || 0,
      incentiveType: EIncentiveType.BONUS,
      automaticallyCreated: true,
      status: ESellCoinsCampaignStatus.INACTIVE,
      source: 'HubSpot'
    });

    if (sellCoinsStatus !== 200 && sellCoinsStatus !== 201) return;

    this.sellCoinsService.changeCampaignStatus(sellCoinsData.id);
  }

  async onSubmit() {
    segmentIo.track('Clicked on Activate my Account (Ownership experience)');

    if (
      this.inviteData.isManagerAlreadyRegistered &&
      this.isFeatureFlagLoginHandleActive
    ) {
      await this.setBusiness().finally(() => this.handleAcceptInvite());
      return;
    }

    eventBus.$emit('accountPasswordFormSubmit');
  }

  verifyCoinFeatures() {
    const { welcomeCoins, loyaltyRewards } = this.salesOnboardingFormData;

    this.loyaltyWithoutSettings = false;
    this.welcomeCoinsWithoutCoins = false;

    if (welcomeCoins && welcomeCoins.enabled && !welcomeCoins.value) {
      this.$notification(
        'Amount of Coins is required for the Welcome Coins campaign.',
        'error'
      );
      this.welcomeCoinsWithoutCoins = true;
    }

    if (
      loyaltyRewards &&
      loyaltyRewards.enabled &&
      (!loyaltyRewards.rewardPercentage ||
        (loyaltyRewards.refundsLimitDays === null ||
          isNaN(loyaltyRewards.refundsLimitDays)))
    ) {
      this.loyaltyWithoutSettings = true;

      if (
        !loyaltyRewards.rewardPercentage &&
        loyaltyRewards.refundsLimitDays === null
      ) {
        this.$notification(
          'Ratio and Refund Policy is required for the Loyalty Program',
          'error'
        );
        return;
      }

      if (!loyaltyRewards.rewardPercentage) {
        this.$notification(
          'Ratio is required for the Loyalty Program',
          'error'
        );
        return;
      }

      this.$notification(
        'Refund Policy is required for the Loyalty Program',
        'error'
      );
    }
  }

  goToNextStep() {
    const nextStepIndex =
      this.activeStepsInTheFlow.indexOf(this.activeStepSlug) + 1;

    const nextStep = this.activeStepsInTheFlow[nextStepIndex];

    if (nextStep === EYourAccountInvitationStepSlug.CONFIRM_YOUR_FEATURES) {
      segmentIo.page('Merchant Activate Account Confirm Your Features');
    }

    if (
      this.activeStepSlug === EYourAccountInvitationStepSlug.CONFIRM_YOUR_INFO
    ) {
      this.verifyOffersLocations();

      if (this.offerWithoutLocation) return;
    } else if (
      this.activatedSomeCoinsFeature &&
      this.activeStepSlug ===
        EYourAccountInvitationStepSlug.CONFIRM_YOUR_FEATURES
    ) {
      this.verifyCoinFeatures();

      if (this.welcomeCoinsWithoutCoins || this.loyaltyWithoutSettings) return;
    }

    this.activeStepSlug = nextStep;
    this.stepIndicator += 1;
  }

  handleBack() {
    segmentIo.track('Clicked on Back (Ownership experience)');
    this.triggerAnimation = false;
    const previousStepIndex =
      this.activeStepsInTheFlow.indexOf(this.activeStepSlug) - 1;

    const previousStep = this.activeStepsInTheFlow[previousStepIndex];
    this.activeStepSlug = previousStep;
    this.stepIndicator -= 1;
  }

  handleClickPreviewOnApp() {
    segmentIo.track('Clicked on Preview on App (Ownership experience)');
    this.previewOnApp();
  }

  previewOnApp() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'previewAppBusiness',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: this.inviteData
      }
    );
  }

  async reloadInviteBusinessInfo() {
    this.offerWithoutLocation = false;
    this.welcomeCoinsWithoutCoins = false;
    this.loyaltyWithoutSettings = false;
    const code = this.inviteData.inviteCode;
    const businessId = this.inviteData.businessId;

    const { data } = await this.managerService.getBusinessInfo(code);

    this.inviteData = {
      ...data,
      inviteCode: code,
      businessId
    };
    setMerchantInviteState(this.inviteData);
  }

  getMessageErrorLogion(response: any): string {
    const statusCode = response.status;
    const data = response.data;

    if (statusCode === HTTPStatus.TOO_MANY_REQUESTS) {
      return data.message[0].constraints.TOO_MANY_REQUESTS;
    }

    return data.message[0].translation.title;
  }

  confirmClaimed() {
    if (!this.inviteData || !this.inviteData.claimed) return;

    removeMerchantInviteState();
    removeMerchantMeetingOboardingState();
    this.$router.push({ name: 'home' });
  }

  mounted() {
    this.confirmClaimed();

    eventBus.$on('reloadInviteBusinessInfo', this.reloadInviteBusinessInfo);
  }

  beforeUnmount() {
    eventBus.$off('reloadInviteBusinessInfo');
  }
}
